import * as React from 'react';
import { ToggleView } from './ToggleView';

export function Toggle({
  value,
  onChange,
  ...props
}: {
  value: boolean;
  onChange?: (newValue: boolean) => void;
  [props: string]: unknown;
}) {
  const [state, setState] = React.useState(value);

  if (state !== value) setState(value);

  function onToggleClicked(newValue: boolean) {
    setState(newValue);

    if (onChange) onChange(newValue);
  }

  return <ToggleView value={state} onChange={onToggleClicked} props={props} />;
}
